// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"h8-z"};